import ReportsFilters from './ReportsFilters';
import KpiCards from './KpiCards';
import ReportTable from './ReportTable';
import { formatCurrency, formatNumber, formatPercent } from './formatters';

const AdminHostReports = ({
  data = [],
  filters,
  onFiltersChange,
  onApply,
  onReset,
  onExport,
  loading,
  exporting,
  hosts = [],
}) => {
  const totals = data.reduce(
    (acc, row) => {
      acc.revenue += Number(row.grossRevenue || 0);
      acc.earnings += Number(row.hostEarnings || 0);
      acc.bookings += Number(row.totalBookings || 0);
      return acc;
    },
    { revenue: 0, earnings: 0, bookings: 0 }
  );

  return (
    <div className="space-y-4">
      <ReportsFilters
        filters={filters}
        onChange={onFiltersChange}
        onApply={onApply}
        onReset={onReset}
        onExport={onExport}
        hosts={hosts}
        showHost
        showGroupBy={false}
        applying={loading}
        exporting={exporting}
      />

      <KpiCards
        items={[
          { label: 'Gross revenue', value: totals.revenue, render: (v) => formatCurrency(v) },
          { label: 'Host earnings', value: totals.earnings, render: (v) => formatCurrency(v) },
          { label: 'Bookings', value: totals.bookings, render: (v) => formatNumber(v) },
        ]}
      />

      <ReportTable
        loading={loading}
        columns={[
          { key: 'hostName', label: 'Host' },
          { key: 'totalProperties', label: 'Properties', render: formatNumber },
          { key: 'totalTours', label: 'Tours', render: formatNumber },
          { key: 'totalBookings', label: 'Bookings', render: formatNumber },
          { key: 'cancelledBookings', label: 'Cancelled', render: formatNumber },
          { key: 'grossRevenue', label: 'Gross', render: (v) => formatCurrency(v) },
          { key: 'hostEarnings', label: 'Earnings', render: (v) => formatCurrency(v) },
          { key: 'occupancyRate', label: 'Occupancy', render: (v) => formatPercent(v) },
        ]}
        rows={data}
        emptyText="No host data for this range."
      />
    </div>
  );
};

export default AdminHostReports;
